import { WarrantyLogModel } from '../../../model/types';
import styles from './styles.module.scss';
import clsx from 'clsx';
import { FC } from 'react';
import { formatDateSafe } from 'utils/formats';

export const SentToWaCell: FC<{ data: WarrantyLogModel }> = ({ data }) => {
  return (
    <div>
      <div className={clsx(styles.textBold, 'text-nowrap')}>{formatDateSafe(data.dateCreate, 'DD/MM/YYYY HH:mm')}</div>
      <div> {data.createUserName}</div>
    </div>
  );
};
